import React from 'react';
export function Qualifications() {
  const certificates = [{
    name: 'BHV Diploma',
    primary: true
  }, {
    name: 'SVPB verklaring',
    primary: true
  }, {
    name: 'Rijbewijs AM, B',
    primary: false
  }, {
    name: 'IT Expertise (Windows/Linux)',
    primary: false
  }, {
    name: 'Meertalig (NL, EN, TR)',
    primary: false
  }];
  return <section className="py-16 md:py-20 border-b border-zinc-800" data-id="element-264">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-265">
        <h2 className="text-2xl md:text-3xl font-light mb-6" data-id="element-266">
          Beveiligingskwalificaties
        </h2>
        <p className="text-zinc-400 mb-8 md:mb-10 text-base max-w-3xl" data-id="element-267">
          Professionele certificeringen en kwalificaties voor
          beveiligingsdiensten
        </p>
        <div className="mb-10 md:mb-12" data-id="element-268">
          <h3 className="text-xl font-medium mb-5 text-slate-300" data-id="element-269">
            Beveiligingscertificaten
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-id="element-270">
            {certificates.filter(cert => cert.primary).map((cert, index) => <div key={index} className="bg-zinc-900 p-5 rounded-none border-l border-slate-700 hover:bg-black transition-all shadow-sm" data-id="element-271">
                  <h3 className="font-medium text-base md:text-lg" data-id="element-272">
                    {cert.name}
                  </h3>
                </div>)}
          </div>
        </div>
        <div className="mb-10 md:mb-12" data-id="element-273">
          <h3 className="text-xl font-medium mb-5 text-slate-300" data-id="element-274">
            Aanvullende kwalificaties
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6" data-id="element-275">
            {certificates.filter(cert => !cert.primary).map((cert, index) => <div key={index} className="bg-zinc-900 p-5 rounded-none border-l border-zinc-800 hover:bg-black transition-all shadow-sm" data-id="element-276">
                  <h3 className="font-medium text-base md:text-lg text-zinc-300" data-id="element-277">
                    {cert.name}
                  </h3>
                </div>)}
          </div>
        </div>
        <div className="mt-10 bg-zinc-900 p-6 rounded-none border-t border-zinc-800 shadow-sm" data-id="element-278">
          <h3 className="text-xl font-medium mb-4 text-slate-300" data-id="element-279">
            Professionele registratie
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 text-base" data-id="element-280">
            <p className="text-zinc-300" data-id="element-281">
              <span className="font-medium" data-id="element-282">KVK nummer:</span> 92847927
            </p>
            <p className="text-zinc-300" data-id="element-283">
              <span className="font-medium" data-id="element-284">BTW nummer:</span> NL004981622B39
            </p>
          </div>
        </div>
      </div>
    </section>;
}